import { Injectable } from '@angular/core';
import { DataModel } from './data.model';

@Injectable()
export class TableModel {
    getTableData(columns: DataModel[]) {
        return new Promise((resolve, reject) => {
            let tableData = [];
            for (let i = 0; i < 15; i++) {
                let obj = {} as any;
                for (let x of columns) {
                    obj[x.id] = '000' + i;
                }
                tableData.push(obj);
            }
            resolve(tableData);
        });

    }
}
